import { useState } from "react";
import styles from "./DashboardAssetCard.module.scss";
import { clsx } from "clsx";
import NthEdition from "../../../../common/features/asset/NthEdition.tsx";
import { useIntl } from "react-intl";
import WhiteAssetCardContainer from "../../../../common/features/asset/WhiteAssetCardContainer.tsx";
import EmptyAssetCard from "../../../../common/features/asset/EmptyAssetCard.tsx";
import { ExploreAugmentedAsset } from "../../../../common/api/decimal/common-types/manageAssets.ts";
import useStandardAssetPopover from "../../common/asset-popover/useStandardAssetPopover.tsx";
import AssetTopRow from "../../../../common/features/asset/AssetTopRow.tsx";
import FirstPopoverItemButton from "../../common/asset-popover/FirstPopoverItemButton.tsx";

function useAlternateLabels(asset: ExploreAugmentedAsset) {
  const intl = useIntl();

  const title = asset.manageAsset.title;

  return {
    "open-book": {
      label: intl.formatMessage({
        defaultMessage: "Continue Reading",
      }),
      ariaLabel: intl.formatMessage(
        {
          defaultMessage: "Continue Reading {title}",
        },
        { title }
      ),
    },
    "access-code-website": {
      label: intl.formatMessage({
        defaultMessage: "Launch",
      }),
      ariaLabel: intl.formatMessage(
        {
          defaultMessage: "Launch {title}",
        },
        { title }
      ),
    },
  };
}

export default function DashboardAssetCard({
  asset,
  dynamicStyles,
  onReturnComplete,
}: {
  asset: ExploreAugmentedAsset;
  dynamicStyles?: React.CSSProperties;
  onReturnComplete: () => void;
}) {
  const [isHidden, setIsHidden] = useState(false);
  const { popoverLinks, renderPopoverLinkDependencies } =
    useStandardAssetPopover(asset, {
      onReturnComplete: () => {
        setIsHidden(true);
        onReturnComplete();
      },
    });
  const alternateLabels = useAlternateLabels(asset);

  if (isHidden) {
    return null;
  }

  return (
    <>
      <WhiteAssetCardContainer
        tagName="div"
        className={styles.outerContainer}
        dynamicStyles={dynamicStyles}
      >
        <EmptyAssetCard
          vbid={asset.manageAsset.vbid}
          type="horizontal"
          tagName="div"
          contentAreaClassName={styles.contentArea}
          primaryAction={popoverLinks[0]}
          className={styles.innerCard}
        >
          <AssetTopRow
            asset={asset.manageAsset}
            license={asset.license}
            links={popoverLinks}
          />
          <div className={styles.title}>{asset.manageAsset.title}</div>
          <NthEdition asset={asset.manageAsset} className={styles.edition} />
          <div className={styles.stickyBottom}>
            <FirstPopoverItemButton
              className={clsx(
                "vst-button-pill",
                "vst-button-variant-outline",
                "vst-button-size-small",
                styles.actionButton
              )}
              asset={asset}
              alternateLabels={alternateLabels}
            />
          </div>
        </EmptyAssetCard>
      </WhiteAssetCardContainer>
      {renderPopoverLinkDependencies()}
    </>
  );
}
